import React, { useState } from 'react';

export default function FormPanel({ props: p, onAction, partId, disabled, dir }) {
  const fields = p.fields || [];
  const [values, setValues] = useState(p.values || {});

  const handleChange = (name, val) => setValues((v) => ({ ...v, [name]: val }));

  return (
    <div className="ui-form-panel" dir={dir}>
      {p.title && <div className="ui-part-title">{p.title}</div>}
      {fields.map((f) => (
        <label key={f.name} className="ui-form-field">
          <span>{f.label || f.name}</span>
          <input
            type={f.type || 'text'}
            value={values[f.name] ?? ''}
            disabled={disabled}
            onChange={(e) => handleChange(f.name, e.target.value)}
          />
        </label>
      ))}
      <button
        type="button"
        className="ui-btn primary"
        disabled={disabled}
        onClick={() =>
          onAction?.({
            actionId: 'form.submit',
            mode: 'patch',
            payload: { values },
            partId,
          })
        }
      >
        {p.submitLabel || 'Submit'}
      </button>
    </div>
  );
}
